(() => {
  const selector = 'select:not([multiple]):not([size]):not(.no-js):not(.product-single__variants):not([data-tis-native-select])';
  const enhanced = new WeakMap();
  let openControl = null;

  function close(control, restoreFocus = false) {
    if (!control) return;
    control.wrapper.removeAttribute('data-open');
    control.trigger.setAttribute('aria-expanded', 'false');
    if (restoreFocus) control.trigger.focus();
    if (openControl === control) openControl = null;
  }

  function open(control) {
    if (openControl && openControl !== control) close(openControl);
    control.wrapper.setAttribute('data-open', '');
    control.trigger.setAttribute('aria-expanded', 'true');
    openControl = control;
  }

  function enhance(select) {
    if (enhanced.has(select) || select.closest('.tis-select')) return;

    const id = select.id || `TisSelect-${Math.random().toString(36).slice(2)}`;
    const listboxId = `${id}-LuxuryMenu`;
    const wrapper = document.createElement('div');
    const trigger = document.createElement('button');
    const menu = document.createElement('div');
    const control = { select, wrapper, trigger, menu };

    wrapper.className = 'tis-select';
    trigger.className = 'tis-select__trigger';
    trigger.type = 'button';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', listboxId);
    menu.className = 'tis-select__menu';
    menu.id = listboxId;
    menu.setAttribute('role', 'listbox');

    if (select.closest('variant-selects')) wrapper.classList.add('tis-select--product');

    select.classList.add('tis-native-select--enhanced');
    select.insertAdjacentElement('afterend', wrapper);
    wrapper.append(trigger, menu);
    enhanced.set(select, control);

    const render = () => {
      const options = [...select.options];
      const selected = options.find((option) => option.selected) || options[0];
      trigger.textContent = selected?.textContent?.trim() || 'Select';
      trigger.disabled = select.disabled;
      menu.replaceChildren();

      options.forEach((option, index) => {
        if (option.disabled && option.value === '') return;

        const item = document.createElement('button');
        item.className = 'tis-select__option';
        item.type = 'button';
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', option.selected ? 'true' : 'false');
        item.dataset.value = option.value;
        item.disabled = option.disabled;
        item.textContent = option.textContent.trim();
        item.addEventListener('click', () => {
          if (option.disabled) return;
          select.selectedIndex = index;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
          render();
          close(control, true);
        });
        menu.append(item);
      });
    };

    trigger.addEventListener('click', () => {
      if (wrapper.hasAttribute('data-open')) close(control);
      else open(control);
    });
    trigger.addEventListener('keydown', (event) => {
      if (!['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(event.key)) return;
      if (!wrapper.hasAttribute('data-open')) {
        event.preventDefault();
        open(control);
        menu.querySelector('.tis-select__option:not(:disabled)')?.focus();
      }
    });
    menu.addEventListener('keydown', (event) => {
      const items = [...menu.querySelectorAll('.tis-select__option:not(:disabled)')];
      const index = items.indexOf(document.activeElement);
      if (event.key === 'Escape') {
        event.preventDefault();
        close(control, true);
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        items[(index + 1) % items.length]?.focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        items[(index - 1 + items.length) % items.length]?.focus();
      } else if (event.key === 'Home') {
        event.preventDefault();
        items[0]?.focus();
      } else if (event.key === 'End') {
        event.preventDefault();
        items.at(-1)?.focus();
      }
    });
    select.addEventListener('change', render);
    new MutationObserver(render).observe(select, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'selected', 'label'] });
    render();
  }

  function enhanceAll(root = document) {
    if (root.matches?.(selector)) enhance(root);
    root.querySelectorAll?.(selector).forEach(enhance);
  }

  document.addEventListener('click', (event) => {
    if (openControl && !openControl.wrapper.contains(event.target)) close(openControl);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && openControl) close(openControl, true);
  });
  document.addEventListener('shopify:section:load', (event) => enhanceAll(event.target));

  const start = () => {
    enhanceAll();
    new MutationObserver((mutations) => mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) enhanceAll(node);
    }))).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
